import BaseMap from '../../BaseMap.jsx'
import usePluginSwap from '../../plugins/usePluginSwap.jsx'
import hotkeys from './hotkeys.mjs'
import ToolBar from './ToolBar.jsx'
import useReadMap from './useReadMap.mjs'
import useMindMapPlugins from './useMindMapPlugins.mjs'

const components = {ToolBar}

const HierarchyMap = ({id, type, ...props}) => {
    const readMap = useReadMap(id, type)

    const plugins = [
        useMindMapPlugins(),
        usePluginSwap(),
    ]

    return (
        <BaseMap
            components={components}
            hotkeys={hotkeys}
            plugins={plugins}
            readMap={readMap}
            {...props}
        />
    )
}

export default HierarchyMap
